import shape5 from "./shape-5.jpg"
import welcomeThumb from "./welcome-thumb.jpeg"
import icon1 from "./icon-1.svg"
import icon2 from "./icon-2.svg"
import icon3 from "./icon-3.svg"

export default { 
    shape5, welcomeThumb, icon1, icon2, icon3
}